export default __webpack_public_path__ + "static/media/success.67597528.png";